import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_ENABLE_ADVOCATES_IDENTIFIED_EXPERIMENT = createFcmDetails(
	'enable_advocates_identified_experiment',
	{
		owner: 'Narwhal',
		context: 'PSF Advocates Flow',
		description: 'Enables the advocates identified experiment for the PSF Advocates Flow.',
		import: false,
	},
);
